<template lang="pug" src="./v-page-loader.pug"></template>

<script>
export default {
    props: {
        show: {
            type: Boolean,
            default: false
        }
    }
};
</script>
